(() => {
  const instances = new Map();
  const sliderUtils = window.AWSliderCoreUtils;

  class AWCollectionPageBanner {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector("[data-aw-collection-page-banner-viewport]");
      this.list = root.querySelector("[data-aw-collection-page-banner-list]");
      this.scrollbar = root.querySelector("[data-aw-collection-page-banner-scrollbar]");
      this.thumb = root.querySelector("[data-aw-collection-page-banner-scrollbar-thumb]");
      this.prevButton = root.querySelector("[data-aw-collection-page-banner-prev]");
      this.nextButton = root.querySelector("[data-aw-collection-page-banner-next]");
      this.rafId = null;

      this.onPrevClick = this.onPrevClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onImageLoad = this.onImageLoad.bind(this);

      this.bindEvents();
      this.update();
    }

    bindEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener("click", this.onPrevClick);
      }

      if (this.nextButton) {
        this.nextButton.addEventListener("click", this.onNextClick);
      }

      if (this.viewport) {
        this.viewport.addEventListener("scroll", this.onScroll, { passive: true });
      }

      window.addEventListener("resize", this.onResize);

      sliderUtils.bindImageLoad(this.root, this.onImageLoad);
    }

    destroy() {
      if (this.prevButton) {
        this.prevButton.removeEventListener("click", this.onPrevClick);
      }

      if (this.nextButton) {
        this.nextButton.removeEventListener("click", this.onNextClick);
      }

      if (this.viewport) {
        this.viewport.removeEventListener("scroll", this.onScroll);
      }

      window.removeEventListener("resize", this.onResize);

      if (this.rafId) {
        window.cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
    }

    isMobileViewport() {
      return window.matchMedia("(max-width: 767px)").matches;
    }

    isSliderActive() {
      if (this.isMobileViewport()) {
        return this.root.classList.contains("aw-collection-page-banner--mobile-slider");
      }

      return this.root.classList.contains("aw-collection-page-banner--desktop-slider");
    }

    getItemDistance() {
      return sliderUtils.getItemDistance({
        list: this.list,
        viewport: this.viewport
      });
    }

    scroll(direction) {
      if (!this.viewport) {
        return;
      }

      const distance = this.getItemDistance();

      if (!distance) {
        return;
      }

      this.viewport.scrollBy({
        left: direction * distance,
        behavior: "smooth"
      });
    }

    onPrevClick() {
      if (this.prevButton && this.prevButton.getAttribute("aria-disabled") === "true") {
        return;
      }

      this.scroll(-1);
    }

    onNextClick() {
      if (this.nextButton && this.nextButton.getAttribute("aria-disabled") === "true") {
        return;
      }

      this.scroll(1);
    }

    onScroll() {
      this.requestUpdate();
    }

    onResize() {
      this.requestUpdate();
    }

    onImageLoad() {
      this.requestUpdate();
    }

    requestUpdate() {
      if (this.rafId) {
        return;
      }

      this.rafId = window.requestAnimationFrame(() => {
        this.rafId = null;
        this.update();
      });
    }

    update() {
      if (!this.viewport) {
        return;
      }

      const sliderActive = this.isSliderActive();
      this.root.classList.toggle("is-slider-active", sliderActive);

      if (!sliderActive) {
        sliderUtils.updateButtonState(this.prevButton, true);
        sliderUtils.updateButtonState(this.nextButton, true);

        sliderUtils.updateScrollbar({
          viewport: this.viewport,
          scrollbar: this.scrollbar,
          thumb: this.thumb,
          enabled: false
        });

        if (this.viewport.scrollLeft !== 0) {
          this.viewport.scrollLeft = 0;
        }

        return;
      }

      const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const current = this.viewport.scrollLeft;
      const hasOverflow = maxScroll > 1;

      sliderUtils.updateButtonState(this.prevButton, !hasOverflow || current <= 1);
      sliderUtils.updateButtonState(this.nextButton, !hasOverflow || current >= maxScroll - 1);
      sliderUtils.updateScrollbar({
        viewport: this.viewport,
        scrollbar: this.scrollbar,
        thumb: this.thumb,
        enabled: hasOverflow
      });
    }
  }

  const init = (container = document) => {
    container.querySelectorAll("[data-aw-collection-page-banner]").forEach((root) => {
      if (instances.has(root)) {
        return;
      }

      instances.set(root, new AWCollectionPageBanner(root));
    });
  };

  const destroy = (container) => {
    container.querySelectorAll("[data-aw-collection-page-banner]").forEach((root) => {
      const instance = instances.get(root);

      if (!instance) {
        return;
      }

      instance.destroy();
      instances.delete(root);
    });
  };

  document.addEventListener("DOMContentLoaded", () => init());
  document.addEventListener("shopify:section:load", (event) => init(event.target));
  document.addEventListener("shopify:section:unload", (event) => destroy(event.target));
})();
